/** Missing metadata in older responses disables the anonymous name. */
export function parseDefaultDisplayName(value: unknown): string | null {
  if (
    typeof value !== "string" ||
    value.trim().length === 0 ||
    Array.from(value).length > 40 ||
    /[\p{Cc}\p{Cf}\p{Cs}]/u.test(value)
  ) {
    return null;
  }
  return value;
}
